import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { Field, getFormValues, InjectedFormProps, reduxForm } from "redux-form";
// import {
//   // SelectField,
//   TextField,
//   SelectButtonFieldOptions,
//   PastDatePicker,
// } from "common-fields";

// import  SelectField from "../../../../commonfields/SelectField";

// import CustomerService from '../../../Services/CustomerService';
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { AxiosError, AxiosResponse } from "axios";
import "./manualTodo.scss";
import { toast } from "react-toastify";
// import SelectButtonField from '../../../commonFields/SelectButtonField';
import { Row, Col } from "reactstrap";
import validate from "./CreateTodoValidate";
import Service from "../../../../services";
import { catchError } from "../../../../utils/Utils";
import FileUpload from "../../../../commonfields/FileUpload";
import { fileFormatSupported, getCompanyLocationNames } from "../../../../utils/GeneralUtils";
import { BankUserContext } from "../../../../bankUserContext";
import FinSpinner from "../../../../commonfields/FinSpinner";
import { TodoModel } from "../../../../models/TodoModel";
import { documentsData, FileData } from "../../../../models/ActionModel";
import ReactFileViewer from "../../../../commonfields/ReactFileViewer";
import SelectField from "../../../../commonfields/SelectField";
import { SelectButtonFieldOptions } from "common-fields/dist/esm/components";
import TextField from "../../../../commonfields/TextField";
import { localToBinaryFileConverter } from "../../../../utils/localToBinaryFileConverter";
import FileViewerModal from "../../../shared/FileViewerModal";

export interface CreateTodoBody {
  name: string;
  assignedTo: string | number;

  notes: string;
  lor?: string | number;
}

const CreateTodoForm: React.FC<
  any & InjectedFormProps<Record<string, unknown>, any>
> = (props: any) => {
  const { invalid } = props;
  const service = React.useMemo(() => new Service(), []);
  const [loader, setLoader] = useState(false);
  const [selectLor, setSelectLor] = useState(false);
  const [allManualTodoUsers, setAllManualTodoUsers] = useState([]);
  const [allLORClients, setAllLORClients] = useState([]);
  const [documents, setDocuments] = useState<any>(null);
  const [viewFile, setViewFileDoc] = useState<boolean>();
  // const [documentsData, setDocumentsData] = useState<any>()
  const context = React.useContext(BankUserContext);

  const appType = [
    {
      value: 17,
      text: "General",
    },
    {
      value: 18,
      text: "LOR",
    },
  ];
  // need to change for UUID
  const getAllManualTodoUsers = () => {
    if (!props?.viewTodo) {
      const data = {

        "screen": "LandingPage",

        "sections": "getAllBankUsersByOrgId",

        "orgId": context?.bankuserDetails?.organization?.orgId,

        "isJsonReturnObject": false

      }
      service
        .getAllBankUsers(data)
        .then((response: any) => {
          const data = response.data.map((element: any) => {
            return {
              text: `${element.text}`,
              value: element.id,
            };
          });
          setAllManualTodoUsers(data);
        });
    }
  };

  const getAllLORClients = () => {
    if (!props?.viewTodo) {
      service
        .getAllLORClients(context?.bankuserDetails?.organization?.orgId)
        .then((response: any) => {
          const data = response.data.map((element: any) => {
            return {
              text: `${getCompanyLocationNames(
                element.company,
                element.locationName
              )}`,
              value: element.clientId,
            };
          });
          setAllLORClients(data);
        });
    }
  };

  const getManualTodosById = () => {
    const data = {
      "screen": "LandingPage",
      "sections": "getManualTodoById",
      "isJsonReturnObject": false,
      "todoUuid": props.viewTodo.todoUuid
    }
    setLoader(true);
    service.getManualTodosById(data)
      .then((response: any) => {
        if (response.data && response.data[0]?.manualTodoDocuments) {
          const data = JSON.parse(response.data[0]?.manualTodoDocuments)?.map((m: any) => {
            return { ...m, path: m.documentName, name: m.documentName }
          })
          props.change("documents", data);

        }

      })
      .catch((err) => catchError(err, true))
      .finally(() => setLoader(false));


  };

  React.useEffect(() => {
    getAllManualTodoUsers();
    getAllLORClients();
    props?.viewTodo?.todoUuid && getManualTodosById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [service]);

  const handleNotesChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (props?.viewTodo && !props?.disableFields) {
      const data = {
        sections: "updateTodo",
        todoUuid: props.viewTodo?.todoUuid,
        notes: e.target.value,
        isManual:props?.viewTodo?.isManual,
      };

      const manualTodo = {
        sections: "updateTodo",
        todoUuid: props.viewTodo.todoUuid,
        isManual: true,
        priority: props.viewTodo.priority,
        status: props.viewTodo.status,
        assignedTo: props.viewTodo.assigned,
        notes: e.target.value,
        updatedAt: new Date()
      };
      setLoader(true);
      props?.viewTodo.todoTypeId == 5
        ? service
          .updateCasemanagementTodo(data)
          .then(() => {
            props?.getTodoById(props.viewTodo?.todoUuid, false);
            // setTimeout(() => getManualTodosById(), 5000)

          })
          .catch((err: AxiosError) => catchError(err, true)).finally(() => {
            setLoader(false);
          })
        : service
          .updateManualTodo(manualTodo)
          .then(() => {
            props?.getTodoById(props.viewTodo?.todoUuid, false);
            // setTimeout(() => getManualTodosById(), 5000)
            props?.getTodo();

          })
          .catch((err: AxiosError) => catchError(err, true)).finally(() => {
            setLoader(false);
          });
    }
  };

  const onChangeType = (e: any) => {
    props.change("selectLOR", "");
    if (e == "18") {
      setSelectLor(true);
    } else {
      setSelectLor(false);
    }
  };

  const uploadManualTodosFile = (
    todoUuid: string,
    files: any,
    updateFileList = false
  ) => {
    if (todoUuid && files && files.length > 0) {
      setLoader(true);
      return service
        .uploadManualTodosFile(todoUuid, files)
        .then(() => {
          setLoader(false);
          updateFileList && toast.success("Todo Updated");
          updateFileList && getManualTodosById();
          setTimeout(() => {
            props?.createTodoToggle && props.createTodoToggle();
          }, 1500);
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
          setLoader(false);
        });
    }
  };

  const CreateTodo = () => {
    setLoader(true);
    const body: CreateTodoBody = {
      name: props.formValues.taskName,
      assignedTo: props.formValues.assignTo,
      notes: props.formValues.notes,
      lor: props.formValues.lor,
    };
    service
      .createManualTodo(body)
      .then(async (response: any) => {

        if (props.formValues.documents) {
          await uploadManualTodosFile(response.data, props.formValues.documents);
          toast.success("Manual Todo Created");
        } else {
          setLoader(false);
          toast.success("Manual Todo Created");
          setTimeout(() => {
            props?.createTodoToggle && props.createTodoToggle();
          }, 1500);
        }
        props?.getTodo();
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        setLoader(false);
      });
  };

  const deleteTodoFile = (item: any) => {

    if (item.documentUniqueId) {
      setLoader(true)
      service.deleteTodoFile(item.documentUniqueId).then((response: any) => {
        toast.success(response.data);
        getManualTodosById();
        props?.getTodo();
      })
        .catch((err: AxiosError) => catchError(err, true))
        .finally(() => setLoader(false))
    } else {
      const files = props.formValues.documents;
      const filtered = files.filter(
        (ele: any, i: number) => ele?.name !== item?.name
      );
      props.change("documents", filtered);
    }
  };

  const displayTodoTypeSelection = () => {
    if (props?.fromViewDetails && props?.viewTodo?.todoType === "LOR") {
      return (
        <Row>
          <Col>
            <div className="companyName">
              {props?.viewTodo?.companyName}
              <div className="leadStatus">
                {props?.viewTodo?.shortCode || "--"}
              </div>
            </div>
          </Col>
        </Row>
      );
    } else if (props?.fromViewDetails && props?.viewTodo) {
      return <br />;
    } else if (props?.viewTodo?.manual && props?.viewTodo?.todoType !== "LOR") {
      return <br />;
    } else {
      return (
        <Row className="selectButtons">
          <Col md="4">
            <Field
              component={SelectButtonFieldOptions}
              isRequired={true}
              name={"todoType"}
              label={"Type"}
              // helpText={""}
              options={appType}
              onChange={(e: any) => {
                onChangeType(e);
              }}
            />
          </Col>
          <Col md="6" className="lor">
            {selectLor ? (
              <Field
                isRequired={true}
                component={SelectField}
                name={"lor"}
                label={"Select LOR:"}
                // helpText={"selectLOR"}
                values={allLORClients}
              />
            ) : null}
          </Col>
        </Row>
      );
    }
  };

  const setViewFile = () => {
    setViewFileDoc(!viewFile)
  };

  const openFileViewer = (document: any) => {

    if (document.documentUniqueId) {
      setLoader(true);
      service
        .getDocuments(document.documentUniqueId)
        .then((response: AxiosResponse<FileData>) => {
          if (fileFormatSupported(response?.data?.fileType)) {
            const documentObject = {
              fileName: response.data.fileName,
              fileType: response.data.fileType,
              uri: `${response.data.fileContent}`,
            };
            setDocuments(documentObject);
            setViewFileDoc(true);

          }
          else {
            toast.error("FileView is not supported");
          }

        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        })
        .finally(() => {
          setLoader(false)
        });
    }
    else {
      const fetchData = async () => {
        try {
          setLoader(true)
          const result: any = await localToBinaryFileConverter(document);
          setDocuments(result)
          setViewFileDoc(true)
          setLoader(false)
        } catch (error) {
          console.error("Error converting file:", error);
          setLoader(false)
        }
      };
      const fullType = document.path.split('.');
      const docType = fullType[fullType.length - 1];
      if (fileFormatSupported(docType)) {
        fetchData();
      }
      else {
        toast.error("FileView is not supported");
      }
    }

  };

  React.useEffect(() => {
    const shouldUpload = props?.formValues?.documents?.filter(
      (each: any) => !each?.documentUniqueId
    );
    if (
      props?.viewTodo?.todoUuid &&
      shouldUpload &&
      shouldUpload.length > 0
    ) {
      uploadManualTodosFile(
        props?.viewTodo?.todoUuid,
        props.formValues.documents,
        true
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.formValues?.documents]);

  return (
    <div className="createTodoForm">
      {loader ? <FinSpinner /> : null}
      <form className="form-group">
        {!props?.fromViewDetails && (
          <h4 className="createTodoFormTitle mb-4">Create New General Task</h4>
        )}
        {!props?.fromViewDetails && (
          <Row>
            <Col>
              <div className="leftInput">
                <Field
                  component={TextField}
                  isRequired={true}
                  type="text"
                  name={"taskName"}
                  label="Task Name"
                  // helpText={"todoDescription"}
                  disabled={props?.disableFields}
                />
              </div>
            </Col>
            <Col>
              <div className="rightInput">
                <Field
                  component={SelectField}
                  isRequired={true}
                  name={"assignTo"}
                  label={"Assign To:"}
                  // helpText={"Assign To"}
                  values={allManualTodoUsers}
                  disabled={props?.disableFields}
                />
              </div>
            </Col>
          </Row>
        )}
        {/* {displayTodoTypeSelection()} */}
        <Field
          component={TextField}
          isRequired={true}
          name={"notes"}
          label={`Notes (${props?.formValues?.notes?.length || 0}/1000)`}
          type="textarea"
          textBlur={handleNotesChange}
          maxlength={1000}
          disabled={props?.disableFields}
        />

        <div className="documentName">
          <Field
            component={FileUpload}
            displayAccepedFormats={false}
            noClick={false}
            noDrag={false}
            name="documents"
            label={"Documents"}
            maxSize={5242880}
            minSize={1024}
            disabled={props?.disableFields}
            showFilesList={true}
            optional={true}
            onHandleClick={openFileViewer}
            type="file"
            onRemoveClick={deleteTodoFile}
            preserveFiles={props?.fromViewDetails ? false : true}

          />
        </div>
        {!props?.fromViewDetails && (
          <Button
            disabled={invalid || props?.disableFields}
            className="createButton"
            onClick={() => CreateTodo()}
          >
            Create
          </Button>
        )}
        <div className="fileViewerModalContainer">
          <FileViewerModal
            viewFile={viewFile}
            setViewFile={setViewFile}
            documentsData={documents}
          />
        </div>
      </form>
    </div>
  );
};

export default connect((state: any, props: any) => {
  return {
    initialValues: props.initialValues,
    formValues: getFormValues("CreateTodoForm")(state),
  };
})(
  reduxForm<Record<string, unknown>, any>({
    form: "CreateTodoForm",
    enableReinitialize: true,
    validate,
  })(CreateTodoForm)
);
